import request from '@/utils/request'

export const getAccountingPeriods = params => request.get('/accounting/accounting-periods', { params })

export const createAccountingPeriod = data => request.post('/accounting/accounting-periods', data)

export const getPeriodChecklist = id => request.get(`/accounting/accounting-periods/${id}/checklist`)

export const closeAccountingPeriod = (id, data = {}) => request.post(`/accounting/accounting-periods/${id}/close`, data)

export const reopenAccountingPeriod = (id, data) => request.post(`/accounting/accounting-periods/${id}/reopen`, data)

export const getPeriodEvents = id => request.get(`/accounting/accounting-periods/${id}/events`)
